// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown[data-v-488081f8]{padding:var(--spacing-1);flex:0 0 320px;border:2px solid var(--primary);text-align:center;border-radius:0;outline:none;max-width:320px;background-color:#fff;color:var(--black)}option[data-v-488081f8],select[data-v-488081f8]{border-radius:0}option[data-v-488081f8]{color:var(--black)}", ""]);
// Exports
module.exports = exports;
